<template>
    <div class="cookie-consent-container" v-if="showConsent">
        <div class="cookie-consent-modal">
            <div class="cookie-consent-desc">
                <p v-if="isMobile">
                    {{ $t("consent.wap-consent") }}
                    <a target="_blank" :href="$t('consent.privacy-url')">
                        {{ $t("consent.privacy") }}
                    </a>
                    {{ $t("consent.end") }}
                </p>
                <p v-else class="cookie-consent-lineheight">
                    {{ $t("consent.pc-consent") }}
                    <a target="_blank" :href="$t('consent.privacy-url')">
                        {{ $t("consent.privacy") }}
                    </a>
                    {{ $t("consent.end") }}
                </p>
            </div>
            <div class="cookie-consent-actions">
                <div class="accept-button" @click="acceptCookies">
                    {{ $t("consent.accept") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import jsonp from "../utils/jsonp";
export default {
    data() {
        return {
            showConsent: false, // Show the consent modal by default
            cookieExpire: 400, //chrome最大只能400天
            domainCookieName: "rf_cookie_consent",
            consentCookieName: "visitor_id",
            isMobile: false
        };
    },
    methods: {
        handleResize() {
            // 更新窗口宽度和高度数据
            let rootHtml, deviceWidth;
            rootHtml = document.documentElement;
            deviceWidth = rootHtml.clientWidth;
            if (deviceWidth < 940) {
                this.isMobile = true;
            } else {
                this.isMobile = false;
            }
        },
        generateRandomID() {
            let result = "";
            const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
            const charactersLength = characters.length;
            for (let i = 0; i < 16; i++) {
                result += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
                );
            }
            return result;
        },
        acceptCookies() {
            this.showConsent = false;
            this.$store.dispatch("SET_COOKIE_ALLOWED", true);
            this.setCookie("lang", this.$i18n.locale);
            this.setCookie(this.domainCookieName, true);
            this.setCookie(this.consentCookieName, this.$store.state.visitorId);
        },
        setCookie(cookieName, cookieValue) {
            let expires = "";
            const date = new Date();
            date.setTime(
                date.getTime() + this.cookieExpire * 24 * 60 * 60 * 1000
            );
            expires = ";expires=" + date.toUTCString();
            // 设置 cookie，包括名称、值和过期时间
            document.cookie = `${cookieName}=${encodeURIComponent(
                cookieValue
            )}${expires};path=/`;
        },
        getCookie(cookieName) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${cookieName}=`);
            if (parts.length === 2) {
                const cookiePart = parts.pop().split(";").shift();
                return decodeURIComponent(cookiePart);
            }
        }
    },
    mounted() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
        // 处理 COOKIE_ALLOWED
        this.$nextTick(() => {
            // 延迟一定时间后显示弹窗，以便动画可以播放
            const cookieValue = this.getCookie(this.domainCookieName);
            if (
                cookieValue === undefined ||
                cookieValue === "false" ||
                cookieValue === null
            ) {
                this.showConsent = true;
                this.$store.dispatch("SET_COOKIE_ALLOWED", false);
            }
            if (cookieValue === "true") {
                this.showConsent = false;
                this.$store.dispatch("SET_COOKIE_ALLOWED", true);
                this.setCookie(this.domainCookieName, true);
            }
            // 处理VISITOR_ID
            const cookieConsent = this.getCookie(this.consentCookieName);
            if (
                cookieConsent === undefined ||
                cookieConsent === null ||
                cookieConsent === ""
            ) {
                this.$store.dispatch("SET_VISITOR_ID", this.generateRandomID());
            } else {
                this.$store.dispatch("SET_VISITOR_ID", cookieConsent);
            }
            if (this.getCookie(this.domainCookieName) === "true") {
                this.setCookie(
                    this.consentCookieName,
                    this.$store.state.visitorId
                );
            }
            // 初始化mdata信息
            this.$store.dispatch("INIT_MDATA_INFO");
            this.$store.dispatch("MDATA_VISIT_PAGE");
        });
    }
};
</script>

<style scoped>
@media (max-width: 939px) {
    .cookie-consent-container {
        position: absolute;
        left: 0;
        top: 0.83rem;
        width: 100%;
        background: rgba(51, 51, 51, 0.95);
        color: #fff;
        z-index: 998; /* High z-index to ensure it floats above other elements */
        display: flex;
        justify-items: center;
        justify-content: center;
    }

    .cookie-consent-modal {
        padding: 0.2rem;
        text-align: center;
    }

    .cookie-consent-desc {
        font-weight: 500;
        font-size: 0.3rem;
    }

    .cookie-consent-desc a {
        color: #4ccbff;
        text-decoration: none;
    }
    .cookie-consent-desc a:hover {
        color: #4ccbff;
        text-decoration: none;
    }
    .cookie-consent-desc a:visited {
        color: #4ccbff;
        text-decoration: none;
    }
    .cookie-consent-desc a:link {
        color: #4ccbff;
        text-decoration: none;
    }

    .cookie-consent-actions {
        margin: 0.1rem auto;
        font-size: 0.4rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        justify-items: center;
    }

    .accept-button {
        font-weight: 600;
        text-align: center;
        width: 100%;
        height: 0.4rem;
        line-height: 0.4rem;
        color: white;
        cursor: pointer;
        padding: 0.1rem 0.4rem;
        border-radius: 0.28rem;
        border: 1px solid #cccccc;
        margin-top: 0.1rem;
    }
}

@media (min-width: 940px) {
    .cookie-consent-container {
        top: 0.66rem;
        width: 100%;
        max-width: 1920px;
        background: rgba(51, 51, 51, 0.95);
        color: #fff;
        z-index: 1000; /* High z-index to ensure it floats above other elements */
        display: flex;
        flex-direction: row;
        justify-items: center;
        justify-content: center;
        min-height: 60px;
        line-height: 20px;
        font-size: 14px;
    }

    .cookie-consent-modal {
        flex: 1 1;
        max-width: 900px;
        display: flex;
        align-items: center;
        padding: 13px 15px;
        gap: 20px;
    }

    .cookie-consent-desc {
        font-weight: 400;
        font-size: 17px;
        text-align: left;
        flex: 1;
    }
    .cookie-consent-lineheight {
        line-height: 23px;
    }
    .cookie-consent-desc a {
        color: #4ccbff;
        text-decoration: none;
    }
    .cookie-consent-desc a:hover {
        color: #4ccbff;
        text-decoration: none;
    }
    .cookie-consent-desc a:visited {
        color: #4ccbff;
        text-decoration: none;
    }
    .cookie-consent-desc a:link {
        color: #4ccbff;
        text-decoration: none;
    }

    .cookie-consent-actions {
        margin: 0;
        font-size: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
    }

    .accept-button {
        font-weight: 600;
        text-align: center;
        min-width: 120px;
        height: auto;
        line-height: 20px;
        color: white;
        cursor: pointer;
        padding: 10px 30px;
        border-radius: 20px;
        border: 1px solid #cccccc;
        white-space: nowrap;
        transition: background-color 0.3s ease;
    }

    .accept-button:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }

    /* 定义进入和离开的动画，这里的样式的类明是根据html文档里的transition元素的name生成的，值为  name +-enter-active*/
    .cookie-consent-slide-enter-active,
    .cookie-consent-slide-leave-active {
        transition: all 0.5s ease-in-out; /* 增加到0.5秒 */
    }

    .cookie-consent-slide-enter, .cookie-consent-slide-leave-to /* 修正类名以匹配Vue的默认行为 */ {
        transform: translateY(100%); /* 从底部开始 */
        opacity: 0;
    }
}
</style>
